import { TableCell, TableHead, TableRow } from "@mui/material";

const COLUMNS = ["מקט", "תיאור", "ברקוד", "כמות", "מחיר ליחידה", "מחיר לאחר הנחה", "הנחת סוכן %", "הנחה כוללת %", ""];

const OrderItemsTableHead = () => (
  <TableHead>
    <TableRow>
      <TableCell sx={{ width: 36, bgcolor: "#ebf7ff" }} />
      {COLUMNS.map((col) => (
        <TableCell
          key={col}
          align="center"
          sx={{ fontWeight: "bold", bgcolor: "#ebf7ff", color: "#1f2937", whiteSpace: "nowrap" }}
        >
          {col}
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);

export default OrderItemsTableHead;
